module.exports = __webpack_public_path__ + "static/media/car-1-rocklea.15fdde0f.png";